import { render } from "./organ_unitsView.vue?vue&type=template&id=08259c78&scoped=true"
import script from "./organ_unitsView.vue?vue&type=script&lang=js"
export * from "./organ_unitsView.vue?vue&type=script&lang=js"

import "./organ_unitsView.vue?vue&type=style&index=0&id=08259c78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08259c78"]])

export default __exports__